import { StoreState } from '../../interfaces';

export const initialStoreState: StoreState = {
  editMatchesEventObject: null,
};
